import { render, staticRenderFns } from "./Spring.vue?vue&type=template&id=ffc8d9c2&scoped=true"
import script from "./Spring.vue?vue&type=script&lang=js"
export * from "./Spring.vue?vue&type=script&lang=js"
import style0 from "./Spring.vue?vue&type=style&index=0&id=ffc8d9c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc8d9c2",
  null
  
)

export default component.exports